
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fushiji",
      function () {
        return require("private-next-pages/fushiji/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fushiji"])
      });
    }
  